//属性数据
export const attribute = {
  account: [
    { label: "产品", value: "app_name" },
    { label: "授权状态", value: "permission_status" },
    { label: "优化师", value: "optimizer" },
    // {label: '今日总消耗', value:'today_all_cost'},
    // {label: '昨日总消耗', value:'yesterday_all_cost'},
    { label: "账户余额", value: "balance" },
    { label: "现金余额", value: "cash" },
    { label: "赠款余额", value: "grant" },
    // {label: '可消耗天数', value:'day_remain'},
    { label: "预算", value: "budget", width: "140" },
  ],
  adGroup: [
    { label: "广告账户ID", value: "advertiser_id" },
    { label: "广告账户名称", value: "advertiser_name" },
    { label: "广告组ID", value: "campaign_id" },
    { label: "推广目的", value: "landing_type" },
    { label: "状态", value: "data_status" },
    { label: "创建时间", value: "createTimeStr" },
    { label: "预算", value: "budget" },
  ],
  plan: [
    { label: "产品", value: "app_name" },
    { label: "广告账户ID", value: "advertiser_id" },
    { label: "广告账户名称", value: "advertiser_name" },
    { label: "广告计划ID", value: "ad_id" },
    { label: "状态", value: "data_status" },
    { label: "建议", value: "suggust" },
    { label: "预算", value: "budget" },
    { label: "出价", value: "cpa_bid" },
    { label: "深度出价", value: "deep_cpabid" },
    { label: "转化类型", value: "covert_type" },
    { label: "广告组ID", value: "campaign_id" },
    { label: "开始时间", value: "start_time" },
    { label: "结束时间", value: "end_time" },
    { label: "创建时间", value: "createTimeStr" },
    { label: "投放位置", value: "delivery_placement" },
    { label: "诊断标签", value: "diagnosis_tag" },
  ],
  creative: [
    { label: "产品", value: "app_name" },
    { label: "广告账户ID", value: "advertiser_id" },
    { label: "广告账户名称", value: "advertiser_name" },
    { label: "广告计划ID", value: "ad_id" },
    { label: "广告计划名称", value: "ad_name" },
    { label: "广告组ID", value: "campaign_id" },
    { label: "状态", value: "data_status" },
    { label: "建议", value: "suggust" },
    { label: "创意方式", value: "creative_material_mode" },
    { label: "素材类型", value: "image_mode" },
  ],
};

//基础数据
export const baseData = [
  { label: "花费", value: "cost" },
  { label: "展示数", value: "show_cnt" },
  { label: "点击数", value: "click_cnt" },
  { label: "点击率", value: "ctr" },
  { label: "点击成本", value: "avg_click_cost" },
  { label: "千次展示成本", value: "avg_show_cost" },
];

//应用数据
export const appData = [
  { label: "转化数", value: "convert_cnt" },
  { label: "转化成本", value: "convert_cost" },
  { label: "转化率", value: "convert_rate" },
  { label: "深度转化次数", value: "deep_convert" },
  { label: "深度转化成本", value: "deep_convert_cost" },
  { label: "深度转化率", value: "deep_convert_rate" },
  { label: "转化数(计费时间)", value: "attribution_convert" },
  { label: "转化成本(计费时间)", value: "attribution_convert_cost" },
  { label: "深度转化数(计费时间)", value: "attribution_deep_convert" },
  { label: "深度转化成本(计费时间)", value: "attribution_deep_convert_cost" },
  { label: "安卓下载开始数", value: "download_start" },
  { label: "安卓下载开始成本", value: "download_start_cost" },
  { label: "安卓下载开始率", value: "download_start_rate" },
  { label: "安卓下载完成数", value: "download_finish" },
  { label: "安卓下载完成成本", value: "download_finish_cost" },
  { label: "安卓下载完成率", value: "download_finish_rate" },
  { label: "点击安装数", value: "click_install" },
  { label: "安卓安装完成数", value: "install_finish" },
  { label: "安卓安装完成成本", value: "install_finish_cost" },
  { label: "安卓安装完成率", value: "install_finish_rate" },
  { label: "注册数", value: "register_cnt" },
  { label: "注册成本", value: "active_register_cost" },
  { label: "注册率", value: "active_register_rate" },
  { label: "激活数", value: "active_cnt" },
  { label: "激活成本", value: "active_cost" },
  { label: "激活率", value: "active_rate" },
  { label: "次留数", value: "attribution_next_day_open_cnt" },
  { label: "次留成本", value: "attribution_next_day_open_cost" },
  { label: "次留率", value: "attribution_next_day_open_rate" },
  // {label: '首次付费数',value: 'pay_count'},
  // {label: '首次付费成本',value: 'active_pay_cost'},
  // {label: '首次付费率',value: 'active_pay_rate'},
];

//视频数据
export const videoData = [
  // {label: '有效播放率',value: 'valid_play_rate'},
  // {label: '播完率',value: 'play_over_rate'},
  // {label: '平均单次播放时长',value: 'average_play_time_per_play'},
];
/* 素材类型字段对象 */
export const materialFieldsObj = [
  { name: "素材类别", key: "materialTypes", optionsName: "materialTypeList", type: 1 },
  { name: "尺寸", key: "resolutions", optionsName: "dimensionList", type: 2 },
  { name: "语言", key: "langs", optionsName: "languageList", type: 3 },
  { name: "设计", key: "designerIds", optionsName: "designerList", type: 4 },
  { name: "后期", key: "demanderIds", optionsName: "demanderList", type: 5 },
  { name: "玩法", key: "playTypes", optionsName: "playList", type: 7 },
  { name: "组别", key: "groupTypes", optionsName: "groupList", type: 8 },
];
/* 素材类型字段枚举 */
export const materialRuleTypeOptions = [
  { label: "素材类别", value: 1, ruleOptions: "materialTypeRuleList", ruleId: "materialTypeRuleId" },
  { label: "尺寸", value: 2, ruleOptions: "dimensionRuleList", ruleId: "dimensionRuleId" },
  { label: "语言", value: 3, ruleOptions: "lanauageRuleList", ruleId: "langRuleId" },
  { label: "设计", value: 4, ruleOptions: "designerRuleList", ruleId: "designerRuleId" },
  { label: "后期", value: 5, ruleOptions: "demanderRuleList", ruleId: "demanderRuleId" },
  { label: "标签", value: 6, ruleOptions: "tagRuleList", ruleId: "tagRuleId" },
  { label: "玩法", value: 7, ruleOptions: "playTypeRuleList", ruleId: "playRuleId" },
  { label: "组别", value: 8, ruleOptions: "groupTypeRuleList", ruleId: "groupRuleId" },
];
